var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"ci-vehicle-form-nav"},[_c('ul',{staticClass:"ci-vehicle-form-nav__list"},_vm._l((_vm.anchorsList),function(item,i){return _c('li',{key:("item-" + i),staticClass:"ci-vehicle-form-nav__list-item",class:{
        'ci-vehicle-form-nav__list-item--active':
          item.className === _vm.activeAnchor
      },on:{"click":function($event){return _vm.scrollTo(item.className)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }